import React from 'react';
import AppBar, { AppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import { Theme, useTheme, styled } from '@mui/material';

export type GlobalHeaderProps = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  center?: React.ReactNode;
  props?: AppBarProps;
  theme?: Theme;
  position?: 'static' | 'sticky' | 'fixed';
};

const Header = styled(AppBar)`
  &.MuiAppBar-root {
    background: ${({ theme }) => theme?.palette.greyscale.black};
    border-bottom-width: 4px;
    border-bottom-color: ${({ theme }) => theme?.palette.greyscale['07']};
    min-height: 68px;
    transform: translateZ(0);
    will-change: transform;

    @media (max-width: ${({ theme }) => theme?.breakpoints.values.md}px) {
      border-bottom-width: 2px;
    }
  }
`;

const Nav = styled(Toolbar)`
  background: none;
  min-height: 68px;
  max-width: ${({ theme }) => theme?.breakpoints.values.xl}px;
  width: 100%;
  align-self: center;
`;

const Group = styled(Grid)`
  align-items: center;
  line-height: 0;
`;

const Left = styled(Grid)`
  justify-content: left;
  align-items: center;
  display: grid;
  grid-auto-flow: column;
`;

const Center = styled(Grid)`
  justify-content: center;
  align-items: center;
  display: grid;
  grid-auto-flow: column;
`;

const Right = styled(Grid)`
  justify-content: right;
  align-items: center;
  display: grid;
  grid-auto-flow: column;
`;

const GlobalHeader: React.FC<GlobalHeaderProps> = ({
  left,
  right,
  center,
  position,
  ...props
}) => {
  const theme = useTheme();
  return (
    <Header theme={theme} position={position || 'static'} {...props}>
      <Nav>
        <Group container>
          {left && (
            <Left item xs>
              {left}
            </Left>
          )}
          {center && (
            <Center item xs>
              {center}
            </Center>
          )}
          {right && (
            <Right item xs>
              {right}
            </Right>
          )}
        </Group>
      </Nav>
    </Header>
  );
};

export default GlobalHeader;
